import React from 'react';
import { Button } from 'react-bootstrap';
import ActionButton from 'components/ActionButton';
import { AgroTrackingForecastPreference } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/preference';
import useSelectPreference from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useSelectPreference';

export default function Preference({
  preference,
  onDelete,
  deleteLoading,
}: {
  preference: AgroTrackingForecastPreference,
  onDelete: () => void,
  deleteLoading: boolean,
}) {
  const { selectPreference } = useSelectPreference();

  return (
    <div className="d-flex flex-row align-items-center">
      <Button
        variant="link"
        onClick={selectPreference(preference)}
        className="btn-control-panel flex-grow-1"
      >
        {preference.name}
      </Button>
      <ActionButton
        loading={deleteLoading}
        onClick={onDelete}
        icon="trash"
        type="tertiary"
        small
      />
    </div>
  );
}
